module.exports = __webpack_public_path__ + "icon_point.png?d46512144f35504c6083f345f843b154";


//////////////////
// WEBPACK FOOTER
// ./images/icon_point.png
// module id = 10
// module chunks = 0